import { useState } from "react";
import { useLang } from "../../context/LanguageContext";
import { X, ChevronLeft, ChevronRight } from "lucide-react";

const IMAGES = [
  "/photos/erato-1.jpg",
  "/photos/thalia-1.jpg",
  "/photos/people-1.jpg",
  "/photos/yard-1.jpg",
  "/photos/erato-3.jpg",
  "/photos/people-2.jpg",
  "/photos/thalia-3.jpg",
  "/photos/yard-3.jpg",
  "/photos/erato-5.jpg",
  "/photos/people-3.jpg",
  "/photos/thalia-5.jpg",
  "/photos/yard-evening.jpg",
  "/photos/people-4.jpg",
  "/photos/erato-2.jpg",
  "/photos/people-5.jpg",
  "/photos/thalia-4.jpg",
  "/photos/yard-4.jpg",
  "/photos/people-6.jpg",
];

export default function Gallery() {
  const { t } = useLang();
  const [active, setActive] = useState(null);

  const prev = () => setActive((i) => (i - 1 + IMAGES.length) % IMAGES.length);
  const next = () => setActive((i) => (i + 1) % IMAGES.length);

  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="py-16 sm:py-24 lg:py-32 bg-white overflow-x-hidden"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mb-10 sm:mb-16">
          <p className="uppercase text-xs sm:text-sm tracking-[0.25em] text-[#6B705C] mb-3 sm:mb-4">
            {t.gallery.overline}
          </p>
          <h2 className="font-serif text-3xl sm:text-5xl lg:text-6xl text-[#1A2B4C] tracking-tight leading-[1.05]">
            {t.gallery.title}
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 auto-rows-[140px] sm:auto-rows-[200px] gap-2 sm:gap-3 md:gap-4">
          {IMAGES.map((src, idx) => {
            const spans = [
              "col-span-2 row-span-2",
              "",
              "row-span-2",
              "",
              "",
              "col-span-2",
              "",
              "",
              "row-span-2",
              "col-span-2",
              "",
              "",
              "",
              "",
              "col-span-2",
              "",
              "row-span-2",
              "",
            ];
            return (
              <button
                key={src}
                onClick={() => setActive(idx)}
                data-testid={`gallery-thumb-${idx}`}
                className={`relative overflow-hidden rounded-2xl group ${spans[idx] || ""}`}
              >
                <img
                  src={src}
                  alt={`Gallery ${idx + 1}`}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-[1.2s]"
                />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/15 transition-colors" />
              </button>
            );
          })}
        </div>
      </div>

      {active !== null && (
        <div
          data-testid="lightbox"
          className="fixed inset-0 z-[100] lightbox-overlay flex items-center justify-center p-4 animate-fade-in"
          onClick={() => setActive(null)}
        >
          <button
            onClick={() => setActive(null)}
            data-testid="lightbox-close"
            className="absolute top-5 right-5 text-white p-2 hover:bg-white/10 rounded-full"
          >
            <X />
          </button>
          <button
            onClick={(e) => {
              e.stopPropagation();
              prev();
            }}
            data-testid="lightbox-prev"
            className="absolute left-4 md:left-10 text-white p-3 hover:bg-white/10 rounded-full"
          >
            <ChevronLeft className="w-7 h-7" />
          </button>
          <img
            src={IMAGES[active]}
            alt="full"
            className="max-h-[88vh] max-w-[92vw] object-contain rounded-xl"
            onClick={(e) => e.stopPropagation()}
          />
          <button
            onClick={(e) => {
              e.stopPropagation();
              next();
            }}
            data-testid="lightbox-next"
            className="absolute right-4 md:right-10 text-white p-3 hover:bg-white/10 rounded-full"
          >
            <ChevronRight className="w-7 h-7" />
          </button>
        </div>
      )}
    </section>
  );
}
